// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, "div.dnd_box___1oxrl {\n  width: 500px;\n  height: 500px;\n  display: inline-block;\n  padding: 5px;\n  border: 1px solid black;\n}\n", "",{"version":3,"sources":["WRechte.less"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,uBAAuB;AACzB","file":"WRechte.less","sourcesContent":["div.dnd_box {\n  width: 500px;\n  height: 500px;\n  display: inline-block;\n  padding: 5px;\n  border: 1px solid black;\n}\n"]}]);
// Exports
exports.locals = {
	"dnd_box": "dnd_box___1oxrl"
};
module.exports = exports;
